module.exports = __webpack_public_path__ + "static/media/surface.ebe0cdbb.png";